var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 318,
    viewBox: "0 0 386 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6031_4351",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 386,
    height: 318
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.727 0.674805H0.748047V317.61H385.727V0.674805Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6031_4351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.362 290.488C256.832 290.488 320.454 226.867 320.454 148.396C320.454 69.9259 256.832 6.3042 178.362 6.3042C99.8913 6.3042 36.2695 69.9259 36.2695 148.396C36.2695 226.867 99.8913 290.488 178.362 290.488Z",
    fill: "#FCF3FD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6031_4351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.653 47.2268H125.076C114.613 47.2268 106.131 55.709 106.131 66.1724V211.852C106.131 222.316 114.613 230.798 125.076 230.798H234.653C245.117 230.798 253.599 222.316 253.599 211.852V66.1724C253.599 55.709 245.117 47.2268 234.653 47.2268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M172.559 70.9087H124.958C121.754 70.9087 119.156 73.5064 119.156 76.7108C119.156 79.9152 121.754 82.5129 124.958 82.5129H172.559C175.764 82.5129 178.361 79.9152 178.361 76.7108C178.361 73.5064 175.764 70.9087 172.559 70.9087Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.764 103.827H124.958C121.754 103.827 119.156 106.425 119.156 109.629C119.156 112.833 121.754 115.431 124.958 115.431H231.764C234.969 115.431 237.566 112.833 237.566 109.629C237.566 106.425 234.969 103.827 231.764 103.827Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.764 136.745H124.958C121.754 136.745 119.156 139.342 119.156 142.547C119.156 145.751 121.754 148.349 124.958 148.349H231.764C234.969 148.349 237.566 145.751 237.566 142.547C237.566 139.342 234.969 136.745 231.764 136.745Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.764 169.663H124.958C121.754 169.663 119.156 172.26 119.156 175.465C119.156 178.669 121.754 181.267 124.958 181.267H231.764C234.969 181.267 237.566 178.669 237.566 175.465C237.566 172.26 234.969 169.663 231.764 169.663Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.958 202.581H231.764C234.973 202.581 237.566 205.174 237.566 208.383C237.566 211.592 234.973 214.185 231.764 214.185H124.958C121.749 214.185 119.156 211.592 119.156 208.383C119.156 205.174 121.749 202.581 124.958 202.581Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6031_4351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.945 26.9312H270.804C267.489 26.9312 264.801 29.7612 264.801 33.2424V68.4339C264.801 71.927 267.489 74.757 270.804 74.757H341.945C345.26 74.757 347.948 71.927 347.948 68.4339V33.2424C347.948 29.7493 345.26 26.9312 341.945 26.9312Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.564 58.4045C286.483 58.4045 289.668 55.2193 289.668 51.2999C289.668 47.3805 286.483 44.1953 282.564 44.1953C278.644 44.1953 275.459 47.3805 275.459 51.2999C275.459 55.2193 278.644 58.4045 282.564 58.4045Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.245 44.1953H329.927C333.847 44.1953 337.032 47.3805 337.032 51.2999C337.032 55.2193 333.847 58.4045 329.927 58.4045H306.245C302.326 58.4045 299.141 55.2193 299.141 51.2999C299.141 47.3805 302.326 44.1953 306.245 44.1953Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.93 274.574C280.181 274.574 294.355 269.956 306.137 262.058L354.33 308.061L371.807 287.777L325.307 243.385C333.892 231.295 338.948 216.518 338.948 200.568C338.948 159.693 305.817 126.562 264.942 126.562C224.067 126.562 190.936 159.693 190.936 200.568C190.936 241.443 224.067 274.574 264.942 274.574H264.93ZM328.054 200.568C328.054 235.167 300.003 263.219 265.404 263.219C230.804 263.219 202.753 235.167 202.753 200.568C202.753 165.968 230.804 137.917 265.404 137.917C300.003 137.917 328.054 165.968 328.054 200.568Z",
    fill: "#736576"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M265.393 264.438C301.034 264.438 329.926 235.807 329.926 200.497C329.926 165.187 301.034 136.555 265.393 136.555C229.751 136.555 200.859 165.187 200.859 200.497C200.859 235.807 229.751 264.438 265.393 264.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.547 200.497L292.165 184.937C293.633 183.398 294.427 181.35 294.403 179.23C294.379 177.111 293.515 175.098 292.011 173.594C290.507 172.102 288.471 171.237 286.339 171.214C284.208 171.19 282.147 171.983 280.596 173.44L264.942 188.999L249.324 173.44C248.578 172.647 247.666 172.019 246.672 171.581C245.665 171.143 244.588 170.906 243.498 170.894C242.409 170.882 241.32 171.084 240.301 171.486C239.283 171.901 238.371 172.504 237.59 173.274C236.82 174.044 236.204 174.956 235.79 175.962C235.375 176.968 235.174 178.046 235.186 179.135C235.198 180.225 235.435 181.29 235.873 182.297C236.311 183.292 236.95 184.192 237.744 184.937L253.386 200.497L237.744 216.056C236.95 216.802 236.311 217.702 235.873 218.696C235.435 219.691 235.198 220.768 235.186 221.858C235.174 222.947 235.375 224.025 235.79 225.031C236.204 226.038 236.808 226.949 237.59 227.719C238.359 228.489 239.283 229.093 240.301 229.507C241.32 229.921 242.397 230.123 243.498 230.099C244.6 230.075 245.677 229.85 246.672 229.412C247.678 228.974 248.578 228.347 249.324 227.553L264.978 211.994L280.632 227.553C282.195 228.915 284.22 229.649 286.304 229.578C288.388 229.507 290.365 228.654 291.833 227.198C293.302 225.73 294.154 223.764 294.213 221.692C294.273 219.62 293.539 217.607 292.153 216.056L276.535 200.497H276.547Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.318 308.06L371.796 287.777L374.424 290.287C376.982 292.726 378.51 296.125 378.675 299.76C378.841 303.383 377.633 306.936 375.324 309.624C373.003 312.311 369.771 313.922 366.325 314.099C362.879 314.277 359.505 313.01 356.959 310.571L354.33 308.06H354.318Z",
    fill: "#736576"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5816 79.9196C55.5579 78.2264 55.3448 76.5331 54.9303 74.8162C53.4384 68.8009 46.8192 64.9408 39.762 64.029C32.7048 63.1172 25.3752 65.1894 22.5452 70.4232C20.923 73.4189 20.7098 76.0003 21.3611 78.1672C22.0242 80.3341 23.5753 82.1221 25.6949 83.5193C31.6035 87.415 41.9407 88.2083 46.6653 86.5743C48.8441 85.8165 50.9754 84.9165 53.0595 83.8745C51.8754 90.6831 47.4468 97.1246 41.55 102.927C28.7143 115.549 8.8096 125.129 -2.03676 128.657C-2.61697 128.847 -2.94852 129.486 -2.75906 130.102C-2.58145 130.706 -1.95388 131.049 -1.37367 130.86C9.68584 127.272 29.9813 117.479 43.0656 104.608C49.8269 97.9535 54.6461 90.47 55.4632 82.6075C70.7381 74.082 83.2896 58.6058 94.0175 45.5926C94.4201 45.1189 94.3609 44.3848 93.8991 43.9703C93.4373 43.5559 92.7387 43.6033 92.3361 44.0887C82.0462 56.581 70.0987 71.4296 55.5816 79.9196ZM53.3555 81.1511C53.4384 79.2565 53.2607 77.3265 52.7753 75.3845C51.4846 70.1745 45.5878 67.0958 39.4778 66.3143C35.7361 65.8288 31.8877 66.2314 28.8683 67.6405C26.9737 68.5286 25.4107 69.8074 24.4634 71.5599C23.232 73.8452 22.9596 75.8108 23.4688 77.4685C23.9779 79.1381 25.2331 80.488 26.879 81.5655C32.2666 85.1178 41.6802 85.8638 45.9785 84.3837C48.5125 83.5075 50.9754 82.4181 53.3673 81.1511H53.3555Z",
    fill: "#E2CEE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.37 196.945C375.294 196.945 378.475 193.764 378.475 189.84C378.475 185.916 375.294 182.735 371.37 182.735C367.446 182.735 364.266 185.916 364.266 189.84C364.266 193.764 367.446 196.945 371.37 196.945Z",
    fill: "#E2CEE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8749 243.586C71.1419 243.112 72.4799 242.485 73.5101 241.561C74.7297 240.472 75.227 239.075 75.5585 237.606C75.9848 235.712 76.1624 233.699 76.6834 231.804C76.8729 231.094 77.24 230.833 77.4057 230.715C77.8083 230.419 78.2109 230.336 78.5898 230.371C79.0398 230.407 79.6674 230.585 80.07 231.39C80.1292 231.508 80.2002 231.674 80.2594 231.923C80.295 232.1 80.3186 232.645 80.366 232.87C80.4607 233.426 80.5436 233.983 80.6265 234.54C80.887 236.399 81.0291 237.973 81.8461 239.679C82.9473 241.999 84.0486 243.408 85.5524 244.036C86.997 244.64 88.7376 244.533 90.9519 244.048C91.165 243.989 91.3663 243.953 91.5794 243.906C92.5504 243.728 93.4858 244.403 93.6753 245.421C93.8647 246.44 93.249 247.434 92.2781 247.659C92.0768 247.707 91.8755 247.754 91.686 247.79C88.6902 248.571 85.2327 251.354 83.2197 253.781C82.6039 254.527 81.6922 256.635 80.7686 257.973C80.0818 258.956 79.3121 259.607 78.6727 259.844C78.2346 259.998 77.8794 259.974 77.5715 259.891C77.1334 259.773 76.7663 259.524 76.494 259.133C76.3401 258.92 76.198 258.624 76.1388 258.257C76.1032 258.079 76.1032 257.629 76.1032 257.416C75.9138 256.73 75.6888 256.066 75.5112 255.38C75.1086 253.734 74.3271 252.692 73.3916 251.318C72.5154 250.028 71.58 249.222 70.1946 248.571C70.017 248.524 68.5723 248.157 68.0632 247.944C67.3172 247.636 66.962 247.103 66.8317 246.819C66.6067 246.345 66.5949 245.919 66.6304 245.575C66.6896 245.054 66.9146 244.616 67.3054 244.261C67.5422 244.036 67.9093 243.823 68.3947 243.716C68.7736 243.633 69.7565 243.586 69.8985 243.586H69.8749ZM78.3649 240.91C78.4359 241.064 78.507 241.23 78.578 241.384C80.1884 244.782 82.0001 246.677 84.1906 247.588L84.2617 247.624C82.7934 248.772 81.4672 250.051 80.4489 251.283C80.0344 251.792 79.4779 252.846 78.874 253.923C78.3293 252.064 77.4413 250.75 76.3282 249.104C75.4757 247.849 74.5757 246.902 73.4745 246.132C74.3271 245.67 75.1441 245.125 75.8546 244.498C77.0387 243.444 77.8202 242.236 78.353 240.91H78.3649Z",
    fill: "#E2CEE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6031_4351",
    x: 66.1309,
    y: 17.2268,
    width: 227.469,
    height: 263.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.647059 0 0 0 0 0.952941 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6031_4351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6031_4351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6031_4351",
    x: 229.801,
    y: -1.06885,
    width: 153.148,
    height: 117.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.647059 0 0 0 0 0.952941 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6031_4351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6031_4351",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/noDataImage.4e4e37595d91e5b989e6264850b76d98.svg";
export { ForwardRef as ReactComponent };